import Vue from 'vue';
import moment from 'moment';
import VueI18n from 'vue-i18n';
import vi from '../../locale/vi';
import en from '../../locale/en';
import ja from '../../locale/ja';

export const LOCAL_STORAGE_LANG_KEY = 'locale';

export type Language = 'en' | 'vi' | 'ja';

export const supportLanguages: Language[] = ['en', 'vi', 'ja'];

export function setLanguage(i18n: VueI18n, lang: Language): void {
  moment.locale(lang);
  if (!supportLanguages.includes(lang)) {
    return;
  }
  i18n.locale = lang;
  localStorage.setItem(LOCAL_STORAGE_LANG_KEY, lang);
  document.documentElement.setAttribute('lang', lang);
}

export default function BootstrapVueI18N(): VueI18n {
  Vue.use(VueI18n);

  let locale: Language = supportLanguages[0];

  try {
    window.navigator.languages
      .map((lang) => lang.split('-'))
      .reverse()
      .forEach(([langCode]) => {
        if (supportLanguages.includes(<Language>langCode)) {
          locale = langCode as Language;
        }
      });
  } catch (e) {
    console.error(e);
    console.error('no default language');
  }

  if (localStorage.getItem(LOCAL_STORAGE_LANG_KEY)) {
    locale = localStorage.getItem(LOCAL_STORAGE_LANG_KEY) as Language;
  }

  document.documentElement.setAttribute('lang', locale);
  moment.locale(locale);

  return new VueI18n({
    locale,
    fallbackLocale: supportLanguages[0],
    messages: {
      vi,
      en,
      ja,
    },
  });
}
